<template>
  <div class="info-wrap">
    <div class="info-content">
      <TitleCard
        :titles="titles"
        :defaultSelected="defaultSelectedId"
        isSwitch
        :showMore="false"
        @switchTitle="switchTitleHandle"
      >
        <InfoList
          :contentList="contentList"
          :tag="tag"
          :code="code"
          :selectedId="selectedId"
        ></InfoList>
      </TitleCard>
      <Pagination
        ref="pagination"
        :paginationOpt="paginationOpt"
        :total="total"
        @change="handlerPaginationChange"
        :pageSize="paginationOpt.pageSize"
        :pageNum="paginationOpt.pageNum"
        v-if="(total > 0 ) && (code !== 'abroadData')"
      ></Pagination>
      <div class="noData" v-if="(total <= 0 ) && (code !== 'abroadData')">
        <img src="../../../public/static/nodata.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import InfoList from './components/infoList/index.vue'
import Pagination from '@/components/common/Pagination'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      titles: [],
      defaultSelectedId: null, // 默认的选中id'
      selectedId: null,
      total: 0,
      // 最初的请求数据的分页参数
      paginationOpt: {
        pageNum: 1,
        pageSize: 10
      },
      contentList: [],
      tag: '',
      code: ''
    }
  },
  components: {
    InfoList,
    Pagination
  },
  computed: {
    ...mapGetters('headerMenu', [
      'setUpdateMenuList'
    ]),
    menuList () {
      return this.setUpdateMenuList
    }
  },
  watch: {
    menuList: {
      handler (val) {
        let { code, selectedId } = this.$route.query
        val.forEach(item => {
          if (item.code === code) {
            //this.titles = item.children //
            item.children.forEach(item => {
              if(item.status === '0') {
                this.titles.push(item)
              }
            })
            console.log('titles', this.titles)
            if (selectedId) { // 从详情的面包屑跳转出来的
              this.titles.forEach(ele => {
                if (Number(ele.id) === Number(selectedId)) {
                  this.tag = ele.label
                  this.code = ele.code
                  this.defaultSelectedId = ele.id
                }
              })
            } else { // 第一次进来选中的tab
              this.tag = this.titles[0].label
              this.code = this.titles[0].code
              this.defaultSelectedId = this.titles[0].id
            }
            this.selectedId = this.defaultSelectedId
            let params = {
              code: this.code,
              moduleId: ''
            }
            this.commonInit(params)
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    commonInit (val) {
      this.$store.dispatch('articleDetail/getHomeList', { ...this.paginationOpt, ...val }).then(res => {
        this.contentList = res.rows
        this.total = res.total
      })
    },
    switchTitleHandle (val) {
      this.selectedId = val.id
      this.tag = val.label
      this.code = val.code
      let params = { code: val.code, moduleId: '' }
      this.paginationOpt.pageNum = 1
      this.paginationOpt.pageSize = 10
      this.commonInit(params)
    },
    handlerPaginationChange (val) {
      
      this.paginationOpt.pageNum = val.current
      this.paginationOpt.pageSize = val.pageSize || this.$refs.pagination.currentSize
      let params = {
        code: this.code, moduleId: ''
      }
      this.commonInit(params)
    }
  }
}
</script>

<style>
</style>
